function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.5a6.086 6.086 0 00-6.048 5.414L5.7 10.18l-.007.056a7.5 7.5 0 01-1.006 2.98l-.028.049-.578.963-.014.024c-.25.417-.458.763-.593 1.049-.136.289-.241.601-.189.933a1.5 1.5 0 00.52.916c.256.216.578.286.896.318.315.032.718.032 1.205.032H18.095c.487 0 .89 0 1.205-.032.318-.032.64-.102.897-.318a1.5 1.5 0 00.52-.916c.051-.332-.053-.644-.19-.933-.134-.286-.342-.632-.592-1.05l-.014-.023-.578-.963-.03-.048a7.5 7.5 0 01-1.005-2.98l-.006-.057-.05-.452a2.982 2.982 0 01-.978.26l.034.303.006.06a8.5 8.5 0 001.14 3.377l.031.052.578.963c.268.446.449.749.56.984.112.238.11.323.105.35a.5.5 0 01-.173.306c-.021.018-.093.064-.355.09-.258.026-.61.027-1.132.027H5.933c-.52 0-.873 0-1.132-.027-.261-.026-.334-.072-.355-.09a.5.5 0 01-.173-.305c-.004-.028-.006-.113.106-.35.11-.236.291-.539.559-.985l.578-.963.03-.052a8.5 8.5 0 001.141-3.378l.007-.06.251-2.265a5.086 5.086 0 018.235-3.41 2.99 2.99 0 01.96-.49A6.073 6.073 0 0012 2.5z",
  stroke: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.102 17.665c.171.957.548 1.802 1.072 2.405.524.603 1.166.93 1.826.93.66 0 1.302-.327 1.826-.93s.9-1.448 1.072-2.405",
  fill: "none",
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 7,
  r: 2,
  fill: "#FE3E2B"
});

var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#002E69",
    stroke: "#002E69"
  }, props), _ref, _ref2, _ref3);
};

export default SvgBell;